export const canViewBranchData = (userProfile, itemBranchId, systemBranches) => {
  if (!userProfile || !userProfile.role) return false;
  if (userProfile.role === 'superAdmin') return true;

  const branchObj = systemBranches.find(b => b.id === itemBranchId);

  // Adminler kendi yetkili oldukları şubeleri veya o şubenin alt şubelerini görebilirler.
  if (userProfile.role === 'admin') {
     return userProfile?.assignedBranches?.includes(itemBranchId) || 
            (branchObj && userProfile?.assignedBranches?.includes(branchObj.parentId));
  }

  // SubAdminler (Personel) kendi atandıkları noktayı görebilirler.
  // Ancak "assignedBranches" içinde zorunluluktan ötürü parent (merkez) ID'si bulunabilir.
  // Eğer personelin hem Merkez hem de Merkez'in bir Alt Şubesine yetkisi varsa,
  // bu personelin aslında o Alt Şubede çalıştığı varsayılır ve doğrudan Merkez'in verilerini görmemesi gerekir.
  if (userProfile.role === 'subAdmin') {
     // Kayıt bir Ana (Merkez) Şubeye aitse:
     if (branchObj && !branchObj.parentId) {
        // Personelin yetkileri arasında bu Merkez'e ait bir Alt Şube var mı?
        const hasSub = userProfile?.assignedBranches?.some(br => {
           const sysBr = systemBranches.find(x => x.id === br);
           return sysBr && sysBr.parentId === branchObj.id;
        });
        
        // Eğer alt şubesi varsa, sadece alt şubeleri görmelidir (Merkezi göremez)
        if (hasSub) {
           return false;
        }
     }
     
     // Diğer her durumda assignedBranches içinde dönen sonuca göre bakarız
     return userProfile?.assignedBranches?.includes(itemBranchId);
  }

  return false;
};

export const getParentBranchName = (branchId, systemBranches) => {
   if (!systemBranches || systemBranches.length === 0) return 'Kurtköy';
   const branchObj = systemBranches.find(b => b.id === branchId);
   if (!branchObj) return 'Kurtköy';
   
   if (branchObj.parentId) {
      const parentObj = systemBranches.find(b => b.id === branchObj.parentId);
      if (parentObj) return parentObj.name;
   }
   
   return branchObj.name;
};
